import { render, staticRenderFns } from "./LiverRotaOrder.vue?vue&type=template&id=5e420f42"
import script from "./LiverRotaOrder.vue?vue&type=script&lang=js"
export * from "./LiverRotaOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports